import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { adminAddMerchantAccount, adminDeleteAccount, adminUpdatePassword, searchUsers } from "../../../services/users";
import PageSelector from '../../../components/PageSelector';
import LoadingPage from "../../../components/Loading";
import DropdownMenu from '../../../components/DropdownMenu'
import { parseJwt } from "../../../utils/util";

const limit = 20
function Page(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const navigateTo = (str) => () => {
        navigate(str)
    }
    const [isloading, setIsloading] = useState(false)


    const [searchParams, setSearchParams] = useSearchParams();
    const [totalItem, setTotalItem] = useState(1)
    const totalPage = Math.ceil(totalItem / limit) || 1
    const [data, setData] = useState([])
    const page = parseInt(searchParams.get('page')) || 1
    const filterLastname = searchParams.get('lastname')
    const filterFirstname = searchParams.get('firstname')
    const filterEmail = searchParams.get('email')
   const { partnerId:id } = parseJwt(props.token?.token);
    //
    const handleSearchLastname = (e) => { setSearchParams({ page: 1, lastname: e.target.value }) }
    const handleSearchFirstname = (e) => { setSearchParams({ page: 1, firstname: e.target.value }) }
    const handleSearchEmail = (e) => { setSearchParams({ page: 1, email: e.target.value }) }
    useEffect(() => {
        if (!props.token.isLogin) return
        const timer = setTimeout(fetchData, 500)
        const interval = setInterval(fetchData, 1000 * 30)
        return () => {
            clearTimeout(timer)
            clearInterval(interval)
        }
    }, [searchParams, props.token])
    async function fetchData() {
        // formatDataForChart()
        const filter = { type: 'merchant', status: 'active', partnerId: id }

        if (filterLastname) filter['data.lastname'] = { "$regex": filterLastname, "$options": 'i' }
        if (filterFirstname) filter['data.firstname'] = { "$regex": filterFirstname, "$options": 'i' }
        if (filterEmail) filter['email'] = { "$regex": filterEmail, "$options": 'i' }
        const res = await searchUsers(props.token.token, filter, { limit, skip: limit * (page - 1), sort: { _id: -1 } })
        console.log(res)
        if (res.errno) return
        setTotalItem(res.count)
        setData(res.result)

        const toPage = Math.ceil(res.count / limit) || 1
        if (page > toPage) handleParamChange('page', 1)
    }
    const handleSelectPage = (p) => () => {
        if (p > totalPage || p < 1) return;
        searchParams.delete('page')
        searchParams.set('page', p)
        setSearchParams(searchParams)
    }
    function handleParamChange(key, val) {
        searchParams.delete(key)
        if (val !== '') searchParams.set(key, val)
        setSearchParams(searchParams)
    }
    const [isAdding, setisAdding] = useState(false)

    const handleAddNewMerchant = async () => {
        let { email, firstname, lastname, password } = isAdding
        if (!email) return alert('請輸入電郵地址')
        if (!firstname) return alert('請輸入姓(Surname)')
        if (!lastname) return alert('請輸入名(Firstname)')
        if (!password) return alert('請輸入密碼')
        if (password.length < 5) return alert('密碼長度必須大於5')
        setIsloading(true)
        const res = await adminAddMerchantAccount(props.token.token, { email, firstname, lastname, password, partnerId: id })
        setIsloading(false)
        if (res.errno) return alert('新增失敗: ' + JSON.stringify(res.message))
        if (res.result) {
            alert('新增成功')
            setisAdding(false)
            fetchData()
        }
    }

    const [isUpdatingPassword, setisUpdatingPassword] = useState(false)
    const handleUpdatePassword = async () => {
        let { password } = isUpdatingPassword
        if (!password) return alert('請輸入密碼')
        if (password.length < 5) return alert('密碼長度必須大於5')
        setIsloading(true)
        const res = await adminUpdatePassword(props.token.token, isUpdatingPassword.userId, password)
        setIsloading(false)
        if (res.errno) return alert('更新失敗: ' + JSON.stringify(res.message))
        if (res.result) {
            alert('更新成功')
            setisUpdatingPassword(false)
            fetchData()
        }
    }
    const [isDeleteing, setisDeleting] = useState(false)
    const handleDeleteMerchant = async () => {
        setIsloading(true)
        const res = await adminDeleteAccount(props.token.token, isDeleteing.userId)
        setIsloading(false)
        if (res.errno) return alert('刪除失敗: ' + JSON.stringify(res.message))
        if (res.result) {
            alert('刪除成功')
            setisDeleting(false)
            fetchData()
        }
    }

    return (
        <div className="w-full h-full flex flex-col items-center justify-start bg-[#ddd] overflow-hidden p-[16px]">
            <div className="w-full flex flex-row gap-[16px] flex-wrap items-center justify-start">
                <input onChange={handleSearchLastname} placeholder="按姓氏搜尋" className="p-[4px] rounded-[4px]" />
                <input onChange={handleSearchFirstname} placeholder="按名字搜尋" className="p-[4px] rounded-[4px]" />
                <input onChange={handleSearchEmail} placeholder="透過電子郵件搜尋" className="p-[4px] rounded-[4px]" />
                {/* <div className="flex-1 flex flex-row gap-[8px] items-center justify-end">
                    <div className="cursor-pointer text-[12px] text-[#6E604C] font-[700] px-[8px] py-[4px] rounded-[4px] bg-[#fff] hover:bg-[#ddd] transition-all duration-200 ease-in-out" onClick={() => { setisAdding({}) }}>
                        新增管理員
                    </div>
                </div> */}
            </div>
            <div className="flex-1 w-full flex flex-col py-[16px]" style={{ overflowY: 'auto' }}>
                {/*Header */}
                <div className="flex flex-row justify-betwen items-center w-full text-[12px] text-[#6E604C] font-[700] pb-[8px]" style={{ borderBottom: '2px solid #6E604C' }}>
                    <div className="flex-[2]">電郵地址(Email)</div>
                    <div className="flex-1">姓(Surname)</div>
                    <div className="flex-1">名(Firstname)</div>
                    {/* <div className="w-[100px]"></div>
                    <div className="w-[100px]"></div> */}
                </div>

                <div className="flex-1 w-full flex flex-col mt-[16px]">
                    {data?.map((item, index) =>
                        <div key={item?._id} className="flex flex-row justify-betwen items-center w-full text-[12px] text-[black] font-[400] py-[8px]" style={{ borderBottom: '.5px solid #fff' }}>
                            <div className="flex-[2]">{item?.email || ''}</div>
                            <div className="flex-1">{item?.data?.lastname || ''}</div>
                            <div className="flex-1">{item?.data?.firstname || ''}</div>
                            {/* <div className="w-[100px]">
                                <div className="cursor-pointer hover:opacity-[.5]" onClick={() => { setisUpdatingPassword({ userId: item?._id, email: item?.email }) }} >更改密碼</div>
                            </div>
                            <div className="w-[100px]">
                                <div className="cursor-pointer hover:opacity-[.5]" onClick={async () => { setisDeleting({ userId: item?._id, email: item?.email }) }} >刪除</div>
                            </div> */}
                        </div>
                    )}
                </div>
            </div>


            <PageSelector page={page} total={totalItem} totalPage={totalPage} handleSelectPage={handleSelectPage} />

            {isAdding &&
                <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-[#00000080] z-[9999]">
                    <div className="w-[400px] bg-[#fff] rounded-[8px] flex flex-col items-center justify-start p-[16px]">
                        <div className="text-[16px] text-[#6E604C] font-[700]">新增管理員</div>

                        <div className="flex flex-row gap-[16px] mt-[16px] w-full">電郵地址</div>
                        <input onChange={(e) => { setisAdding({ ...isAdding, email: e.target.value }) }} placeholder="電郵地址" className="p-[4px] rounded-[4px] border-[black] border-[1px] w-full" />
                        <div className="flex flex-row gap-[16px] mt-[16px] w-full">
                            姓(Surname)
                        </div>
                        <input onChange={(e) => { setisAdding({ ...isAdding, lastname: e.target.value }) }} placeholder="姓(Surname)" className="p-[4px] rounded-[4px] border-[black] border-[1px] w-full" />
                        <div className="flex flex-row gap-[16px] mt-[16px] w-full">
                            名(Firstname)
                        </div>
                        <input onChange={(e) => { setisAdding({ ...isAdding, firstname: e.target.value }) }} placeholder="名(Firstname)" className="p-[4px] rounded-[4px] border-[black] border-[1px] w-full" />
                        <div className="flex flex-row gap-[16px] mt-[16px] w-full">
                            密碼
                        </div>
                        <input onChange={(e) => { setisAdding({ ...isAdding, password: e.target.value }) }} placeholder="密碼" className="p-[4px] rounded-[4px] border-[black] border-[1px] w-full" />

                        <div className="flex-1 w-full flex flex-row gap-[8px] items-center justify-end mt-[64px]">
                            <div className="cursor-pointer text-[12px] text-[#6E604C] font-[700] px-[8px] py-[4px] rounded-[4px] bg-[#fff] hover:bg-[#ddd] transition-all duration-200 ease-in-out" onClick={() => { setisAdding(false) }}>
                                取消
                            </div>
                            <div className="cursor-pointer text-[12px] text-[#6E604C] font-[700] px-[8px] py-[4px] rounded-[4px] bg-[#fff] hover:bg-[#ddd] transition-all duration-200 ease-in-out" onClick={handleAddNewMerchant}>
                                確定
                            </div>
                        </div>
                    </div>
                </div>
            }
            {isUpdatingPassword &&
                <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-[#00000080] z-[9]">
                    <div className="w-[400px] bg-[#fff] rounded-[8px] flex flex-col items-center justify-start p-[16px]">
                        <div className="text-[16px] text-[#6E604C] font-[700]">更改密碼: {isUpdatingPassword.email}</div>

                        <div className="flex flex-row gap-[16px] mt-[16px] w-full">
                            新密碼
                        </div>
                        <input onChange={(e) => { setisUpdatingPassword({ ...isUpdatingPassword, password: e.target.value }) }} placeholder="新密碼" className="p-[4px] rounded-[4px] border-[black] border-[1px] w-full" />

                        <div className="flex-1 w-full flex flex-row gap-[8px] items-center justify-end mt-[64px]">
                            <div className="cursor-pointer text-[12px] text-[#6E604C] font-[700] px-[8px] py-[4px] rounded-[4px] bg-[#fff] hover:bg-[#ddd] transition-all duration-200 ease-in-out" onClick={() => { setisUpdatingPassword(false) }}>
                                取消
                            </div>
                            <div className="cursor-pointer text-[12px] text-[#6E604C] font-[700] px-[8px] py-[4px] rounded-[4px] bg-[#fff] hover:bg-[#ddd] transition-all duration-200 ease-in-out" onClick={handleUpdatePassword}>
                                確定
                            </div>
                        </div>
                    </div>
                </div>
            }
            {isDeleteing &&
                <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-[#00000080] z-[9]">
                    <div className="w-[400px] bg-[#fff] rounded-[8px] flex flex-col items-center justify-start p-[16px]">
                        <div className="text-[16px] text-[#6E604C] font-[700]">
                            確定刪除
                        </div>
                        <div className="text-[16px] text-[black] mt-[20px] font-[400]">
                            {isDeleteing.email}
                        </div>


                        <div className="flex-1 w-full flex flex-row gap-[8px] items-center justify-end mt-[64px]">
                            <div className="cursor-pointer text-[12px] text-[#6E604C] font-[700] px-[8px] py-[4px] rounded-[4px] bg-[#fff] hover:bg-[#ddd] transition-all duration-200 ease-in-out" onClick={() => { setisDeleting(false) }}>
                                取消
                            </div>
                            <div className="cursor-pointer text-[12px] text-[#6E604C] font-[700] px-[8px] py-[4px] rounded-[4px] bg-[#fff] hover:bg-[#ddd] transition-all duration-200 ease-in-out" onClick={handleDeleteMerchant}>
                                確定
                            </div>
                        </div>
                    </div>
                </div>
            }
            {isloading && <LoadingPage />}
        </div>
    )
}


export default connect((store) => {
    return {
        token: store.tokenReducer,
        control: store.controlReducer,
    }
})(Page)


